module.exports = __webpack_public_path__ + "static/media/help.8ed59a9c.svg";